import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import LanguageSelector from '../../../components/ParametersPage/Language';

const mapStateToProps = (state: StoreState) => {
	const { locale } = state.i18n;
	return { language: locale };
};

export default connect(mapStateToProps)(LanguageSelector);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ParametersPage/Language/index.tsx